import React from 'react';
import { formatNormalizedScorePercent } from 'js/utils/format';
import classNames from 'classnames';
import Variability from './Variability';

const QuestionSubview = ({ question }) => {
  const score = question?.normalizedScore ?? null;

  return (
    <>
      <section className="figure-stats">
        <label>Question</label>
        <h3 className="view-name">{question?.name ?? question?.key}</h3>
        <table style={{ width: '100%' }}>
          <tbody>
            <tr>
              <td>
                <label>Mean Score</label>
                <h5 className={classNames({ 'text-muted': score === null })}>
                  {score === null ? 'N/A' : formatNormalizedScorePercent(score)}
                </h5>
              </td>
              <td>
                <label>Median Score</label>
                <h5 className={classNames({ 'text-muted': score === null })}>
                  {score === null ? 'N/A' : formatNormalizedScorePercent(score)}
                </h5>
              </td>
            </tr>
            <tr>
              <td>
                <label>Variability</label>
                <Variability varianceScore={null} />
              </td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </section>
      <section className="figure-spacer"></section>
      <section className="figure-detail" />
    </>
  );
};

export default QuestionSubview;
